<!-- @migration-task Error while migrating Svelte code: Can't migrate code with afterUpdate. Please migrate by hand. -->
<script lang="ts">
	import {
		ArcElement,
		BarController,
		BarElement,
		CategoryScale,
		Chart,
		DoughnutController,
		Filler,
		Legend,
		LineController,
		LineElement,
		LinearScale,
		PointElement,
		TimeSeriesScale,
		Tooltip,
		type ChartConfiguration,
		type ChartData
	} from 'chart.js';
	import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
	import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
	import { onMount } from 'svelte';

	let {
		config,
		data,
		class: clazz = ''
	}: {
		config: Omit<ChartConfiguration, 'data'>;
		data: ChartData;
		class?: string;
	} = $props();

	let ref: HTMLCanvasElement;

	let chart: Chart;

	Chart.register(
		ArcElement,
		BarController,
		BarElement,
		CategoryScale,
		DoughnutController,
		Filler,
		Legend,
		LineController,
		LineElement,
		LinearScale,
		PointElement,
		TimeSeriesScale,
		Tooltip,
		TreemapController,
		TreemapElement
	);

	onMount(() => {
		chart = new Chart(ref, {
			...config,
			data
		});

		return () => {
			chart.destroy();
		};
	});

	$effect(() => {
		chart.data = data;
		chart.update();
	});
</script>

<canvas bind:this={ref} class={clazz}></canvas>
